import { Vegsystemreferanse } from '@/domain/omrader';
import { Veglenkesekvensposisjon } from '@/domain/Veglenkesekvensposisjon';
import { WKTObject } from '@/domain/WKTObject';
import { Stedsnavn } from '@/server/responses';
import { round } from 'lodash-es';

export enum GeolocationState {
    Inactive,
    Active,
    Follow,
}

export class OverlayState {
    constructor(
        readonly vegsystemreferanseLookup: VegsystemreferanseLookup | null = null,
        readonly geolocationState: GeolocationState = GeolocationState.Inactive,
        readonly placenameMarker: Stedsnavn | null = null,
        readonly measuring = false
    ) {}

    override(modifyObject: {
        [P in keyof OverlayState]?: OverlayState[P];
    }): OverlayState {
        return Object.assign(Object.create(OverlayState.prototype), {
            ...this,
            ...modifyObject,
        });
    }

    withVegsystemreferanseLookup(
        vegsystemreferanseLookup: VegsystemreferanseLookup | null
    ): OverlayState {
        return this.override({ vegsystemreferanseLookup });
    }

    withGeolocationState(geolocationState: GeolocationState): OverlayState {
        return this.override({ geolocationState });
    }

    withMeasuring(measuring: boolean): OverlayState {
        return this.override({ measuring });
    }

    withPlacenameMarker(placenameMarker: Stedsnavn | null): OverlayState {
        return this.override({ placenameMarker });
    }
}

export class VegsystemreferanseLookup {
    readonly east: number;
    readonly north: number;
    readonly vegsystemreferanse: Vegsystemreferanse | null;
    readonly veglenke: Veglenkesekvensposisjon | null;
    readonly geometri: WKTObject | null;
    readonly avstand: number | null;
    readonly kommune?: number | null;
    readonly endDate: string | null = null;

    constructor(
        east: number,
        north: number,
        vegsystemreferanse: Vegsystemreferanse | null = null,
        veglenke: Veglenkesekvensposisjon | null = null,
        geometri: WKTObject | null = null,
        avstand: number | null = null,
        kommune: number | null = null,
        endDate: string | null = null
    ) {
        this.east = round(east, 3);
        this.north = round(north, 3);
        this.vegsystemreferanse = vegsystemreferanse;
        this.veglenke = veglenke;
        this.geometri = geometri;
        this.avstand = avstand;
        this.kommune = kommune;
        this.endDate = endDate;
    }

    override(modifyObject: {
        [P in keyof VegsystemreferanseLookup]?: VegsystemreferanseLookup[P];
    }): VegsystemreferanseLookup {
        return Object.assign(Object.create(VegsystemreferanseLookup.prototype), {
            ...this,
            ...modifyObject,
        });
    }

    withEndDate(endDate: string | null): VegsystemreferanseLookup {
        return this.override({ endDate });
    }
}
